/* eslint-disable no-unused-vars */
import { log } from '@hc/logger';
import { queryClient } from '@hc/utils';
import { toast } from 'react-hot-toast';
import create from 'zustand';

export const useNotification = create((set, get) => ({
  notificationState: {
    notificationData: [],
  },
  loading: null,
  error: null,
  getNotification: async (id) => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query
      const { status, data, error, isFetching } = await queryClient.fetchQuery([
        '/notifications/getAll',
        'post',
        { id },
      ]);
      return set((state) => ({
        loading: false,
        notificationState: {
          ...state.notificationState,
          notificationData: data,
        },
      }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.response?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!',
      );
    }
  },
  softDeleteNotification: async (notification_id) => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query
      const { status } = await queryClient.fetchQuery([
        '/notifications/status',
        'post',
        { notification_id },
      ]);
      if (status?.code === 200) {
        set({ loading: false });
        return status;
      }
      set({ loading: false });
    } catch (error) {
      log('error', error);
      set({ loading: false });
      return toast.error('Something went wrong please try again!');
    }
  },

  notificationUndo: async (notification_id) => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query
      const { status } = await queryClient.fetchQuery([
        '/notifications/undo',
        'post',
        { notification_id },
      ]);
      if (status?.code === 200) {
        set({ loading: false });
        return status;
      }
      set({ loading: false });
    } catch (error) {
      log('error', error);
      set({ loading: false });
      return toast.error('Something went wrong please try again!');
    }
  },
  notificationDelete: async (notification_id) => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query
      const { status } = await queryClient.fetchQuery([
        '/notifications/delete',
        'post',
        { notification_id },
      ]);
      if (status?.code === 200) {
        set({ loading: false });
        return status;
      }
      set({ loading: false });
    } catch (error) {
      log('error', error);
      set({ loading: false });
      return toast.error('Something went wrong please try again!');
    }
  },
}));
